export class Variables {

  public Name: string;
  public Context: string;
  public RequiredInDesign: boolean;
  public VariableType: string;
  public UnitString: string;
  public StepSize: number;
  public UAPath: string;
  public Mode: string;
  public ConstellationDependency = false;
  public DownloadPossible = false;
  public UploadPossible = false;

  constructor(name: string, context: string, variableType: string, unit: string, stepSize: number, uaPath: string, mode: string) {
    this.Name = name;
    this.Context = context;
    this.VariableType = variableType;
    this.UnitString = unit;
    this.StepSize = stepSize;
    this.UAPath = uaPath;
    this.Mode = mode;
  }


}
